import React from 'react';
import classNames from 'classnames';

type PlaceholderProps = {
    image: string;
    message: string;
    hint?: string;
    className?: string;
};
const Placeholder = ({ image, message, hint, className }: PlaceholderProps) => {
    return (
        <div className={classNames('media-library-no-results container-fluid', className)}>
            <div className="row">
                <div className="col-12 py-l5-64 text-center">
                    <img src={image} style={{ maxWidth: 120 }} draggable={false} alt="Icon" />
                    <h5 className="mt-l5-24">{message}</h5>
                    {hint && <p className="mt-l5-8">{hint}</p>}
                </div>
            </div>
        </div>
    );
};

type MediaLibraryNoResultsProps = {
    isInFolder: boolean;
    isInSearch: boolean;
    className?: string;
    isVoiceover: boolean;
    /** Message shown when no items are available (outside of search). Defaults to the
     * clip-creator's "talking head videos" wording; callers selecting general media
     * (e.g. the chat media picker) can pass their own. */
    emptyStateMessage?: string;
};
export const MediaLibraryNoResults = ({
    isInFolder,
    isInSearch,
    className,
    isVoiceover,
    emptyStateMessage = 'No talking head videos available',
}: MediaLibraryNoResultsProps) => {
    if (isInSearch) {
        return (
            <Placeholder
                image="https://cdn.lumen5.com/lumen5-site-images/2025-website-assets/creator_panels/CI_10_NoResults.png"
                message="No results matched your search"
                hint="You may want to try being less specific or rephrasing your search."
            />
        );
    }
    if (isVoiceover) {
        return (
            <Placeholder
                image="https://cdn.lumen5.com/lumen5-site-images/2025-website-assets/creator_panels/CI_5_NoVO.png"
                message="No voiceover files found"
            />
        );
    } else if (isInFolder) {
        return (
            <Placeholder
                image="https://cdn.lumen5.com/lumen5-site-images/empty-folder-icon.png"
                message={emptyStateMessage}
            />
        );
    }
    return (
        <Placeholder
            image="https://cdn.lumen5.com/lumen5-site-images/2025-website-assets/creator_panels/CI_11_UploadedMedia.png"
            message={emptyStateMessage}
        />
    );
};

export default MediaLibraryNoResults;
